<template>
  <section id="chooseAssembly">
    <div id="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/" tag="a">Home</router-link></li>
          <li>
            <router-link to="/rfq/create" tag="a">Create New Quote</router-link>
          </li>
          <li class="last">Choose Assembly</li>
        </ul>
      </div>
    </div>
    <div id="shoppingPO">
      <div class="container">
        <div class="row justify-end">
          <div
            class="col-xs-12 col-md-6 col-lg-5"
          >
            <div class="sp-content text-md-right">
              <div class="poNumber" v-if="!editPoNumber">
                Shopping with Quote Reference:
                <span class="sp-number" v-if="!editPoNumber">{{
                  poNumber
                }}</span>
                <a
                  v-on:click="editPoNumber = !editPoNumber"
                  class="sp-number-edit"
                  v-if="!editPoNumber"
                  >Edit Quote Reference</a
                >
              </div>
              <div v-if="editPoNumber" class="editPONumber">
                <div>Change/Edit Your Quote Reference</div>
                <div class="row justify-end" >
                <input type="text" v-model="poNumber" v-if="editPoNumber" class="w-xs-100 w-md-25" />
                <button
                  @click="changePoNumber(poNumber)"
                  class="btn btn-primary"
                  v-if="editPoNumber"
                >
                  save
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <EmergencyCta></EmergencyCta>
      <h1>Create New Quote for {{ code }}</h1>
      <div class="row align-items-center mb-4">
        <div class="col-12 mb-4 mb-lg-0">
          <b-form>
            <div class="row mb-4 align-items-end">
              <div class="col-md-4 mb-4 mb-md-0">
                <label for="Machine">Select Machine</label>
                <div
                  class="ui fluid search selection dropdown"
                  id="MachineSelect"
                >
                  <input
                    type="hidden"
                    name="machine"
                    v-model="machineId"
                    id="Machine"
                    @change="onMachineChange"
                  />
                  <div class="default text">Select Machine</div>
                  <i class="dropdown icon"></i>
                  <div class="menu">
                    <div
                      class="item"
                      v-for="machine in machines"
                      :key="machine.companyMachineId"
                      v-bind:data-value="machine.value"
                    >
                      {{ machine.text }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 mb-4 mb-md-0">
                <label for="Assembly">Select Assembly</label>
                <div
                  class="ui fluid search selection dropdown"
                  id="AssemblySelect"
                >
                  <input
                    type="hidden"
                    name="assembly"
                    v-model="assemblyId"
                    id="Assembly"
                    @change="onAssemblyChange"
                  />
                  <div class="default text">Select Assembly</div>
                  <i class="dropdown icon"></i>
                  <div class="menu">
                    <div
                      class="item"
                      v-for="assembly in assemblies"
                      :key="assembly.value"
                      v-bind:data-value="assembly.value"
                    >
                      {{ assembly.text }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-4">
                <b-form-checkbox
                  id="configuredParts"
                  v-model="configuredWear"
                  name="configuredParts"
                  value="true"
                  unchecked-value="false"
                >
                  Configured Wear Parts Only
                  <span>Deselect for all parts</span>
                </b-form-checkbox>
              </div> -->
            </div>
          </b-form>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12">
          <h2>Select Assembly for {{ code }}</h2>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-4 mb-5"
          v-for="assembly in assemblies"
          :key="assembly.value"
        >
          <a @click="shopAssembly(assembly.value)" class="assemblyLink">
            <img :src="url + assembly.image" alt="" v-if="assembly.image" />
            <img
              src="../../../assets/img/jc-steele-placehold.jpg"
              alt="JC Steele"
              v-else
            />
            <span>{{ assembly.text }}</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();

import "expose-loader?$!expose-loader?jQuery!jquery";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "RFQ-ChooseAssembly",
  computed: {},
  mounted() {
    this.getMachinesByCompany();

    if (this.$route.params.fullOrder) {
      this.fullOrder = this.$route.params.fullOrder;
    }
  },
  data() {
    return {
      assembly: "",
      assemblies: [],
      assemblyId: "",
      machine: "",
      machines: [],
      machineId: localStorage.machineIdRFQ,
      code: "",
      url: "https://steeleimages.blob.core.windows.net/images/",
      editPoNumber: false,
      poNumber: localStorage.poNumberRFQ,
      // configuredWear: localStorage.configuredWearRFQ,
      fullOrder: "",
    };
  },
  methods: {
    getMachinesByCompany() {
      apiService
        .getMachinesByCompany({ id: localStorage.companyId })
        .then((data) => {
          this.machines = data;
        });

      setTimeout(function() {
        $("#MachineSelect").dropdown("set selected", this.machineId);
        $(".ui.dropdown").dropdown({ fullTextSearch: true });
      }, 1000);

      if (localStorage.machineIdRFQ) {
        this.getSelectItemsByCompanyMachine();
        this.machineDetails(this.machineId);    
      }
    },
    getSelectItemsByCompanyMachine() {
      apiService
        .getSelectItemsByCompanyMachine({
          id: this.machineId,
        })
        .then((request) => {
          this.selectItemsSuccessful(request);
        })
        .catch((err) => this.selectItemsFailed(err));
    },
    selectItemsSuccessful(request) {
      // console.log(request);
      this.assemblies = request;
    },
    selectItemsFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },

    onMachineChange(event) {
      this.machineId = event.target.value;

      this.getSelectItemsByCompanyMachine(this.machineId);
      this.machineDetails(this.machineId);
    },
    onAssemblyChange(event) {
      this.assemblyId = event.target.value;

      this.shopAssembly(event.target.value);
    },

    machineDetails(id) {
      apiService
        .getCompanyMachineDetails({ id: id })
        .then((request) => this.machineSuccessful(request))
        .catch((err) => this.machineFailed(err));
    },
    machineSuccessful(request) {
      this.code = request.code;
    },
    machineFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    shopAssembly(assembly) {
      this.assemblyId = assembly;

      if (this.fullOrder) {
        this.$router.push({
          name: "Create Quote - Shop Assembly",
          params: {
            assemblyId: assembly,
            machineId: this.machineId,
            configuredWear: this.configuredWear,
            fullOrder: this.fullOrder,
          },
        });
      } else {
        this.$router.push({
          name: "Create Quote - Shop Assembly",
          params: {
            assemblyId: assembly,
            machineId: this.machineId,
            configuredWear: this.configuredWear,
          },
        });
      }

      localStorage.assemblyIdRFQ = this.assemblyId;
      localStorage.machineIdRFQ = this.machineId;
      localStorage.poNumberRFQ = this.poNumber;
      localStorage.configuredWearRFQ = this.configuredWear;
    },
    changePoNumber(num) {
      if(num) {
        localStorage.poNumberRFQ = num;
  
        this.editPoNumber = !this.editPoNumber;
      } else {
        this.$bvToast.toast("Please enter a valid Quote Reference to continue", {
          title: "Warning! Quote Reference field cannot be empty",
          autoHideDelay: 5000,
          appendToast: false,
          variant: "danger",
          solid: true
      });
      }
    },
  },
};
</script>
